<section class="container-style">
  <form [formGroup]="formCity">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-4 col-6 mb-1">
        <app-custom-select formControlName="countryId" [labelText]="'País'" [list]="listCountries" [required]="true"
          [recovery]="true" (onChangeSelect)="getCountry($event)">
        </app-custom-select>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-4 col-6 mb-1">
        <app-custom-autocomplete formControlName="departmentId" [labelText]="'Departamento'"
          [list]="listDepartmentsByCountry" [required]="true" [recovery]="true"
          (onChangeSelect)="getDepartment($event)">
        </app-custom-autocomplete>
      </div>
      <div class="col-lg-4 col-md-12 col-sm-4 col-6">
        <app-custom-input-text formControlName="code" [labelText]="'Código'" [required]="true" [recovery]="true"
          (onChangeText)="changeCity()">
        </app-custom-input-text>
      </div>
      <div class="col-lg-8 col-md-12 col-sm-4 col-6">
        <app-custom-input-text formControlName="name" [required]="true" [labelText]="'Nombre'">
        </app-custom-input-text>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end align-items-end mt-sm-2 mt-md-3">
        <app-custom-button [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
          (onClick)="send()"></app-custom-button>
      </div>
    </div>
  </form>
</section>